import { composeIO } from 'react-compose-io'
import { cicloEtapaIO } from './CicloEtapa.IO'
import CicloEtapaView from './CicloEtapa.View'

export const CicloEtapa = composeIO(CicloEtapaView, cicloEtapaIO)
